import StagedRolloutStore from '@shared/svelte/Stores/StagedRolloutStore';
import { get } from "svelte/store";

export const prepareStagedRollouts = (rollouts) => {
  if (rollouts && rollouts.length > 0) {
    window["$rootScope"].rollouts = {};
    rollouts.forEach((sr) => {
      window["$rootScope"].rollouts[sr.name] = sr.status;
    });
  };
  StagedRolloutStore.update((n) => window["$rootScope"].rollouts)
};

export const stagedRolloutCheck = (rolloutName: string): boolean => {
  const rollouts: { [key: string]: boolean } = get(StagedRolloutStore);

  return rollouts && rollouts[rolloutName];
}
